import { render, staticRenderFns } from "./LabelValuePairs.vue?vue&type=template&id=04da3950&"
import script from "./LabelValuePairs.vue?vue&type=script&lang=js&"
export * from "./LabelValuePairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports